import React from 'react'
import PriceUtil from 'utils/price-util'

const productTableColumns = () => {

  //custom cell
  const ImageCell = (row) => (
    <img
      style={{ width: '5rem' }}
      src={ row.cell.value }
      alt={ row.row.original.sku }
    />
  )

  const PriceCell = (row) => PriceUtil.format(row.cell.value)

  return (
    [
      {
        Header         : 'Image',
        accessor       : 'main_image',
        Cell           : ImageCell,
        disableFilters : true
      },
      {
        Header   : 'Name',
        accessor : 'name'
      },
      {
        Header   : 'SKU',
        accessor : 'sku'
      },
      {
        Header   : 'Quantity',
        accessor : 'quantity'
      },
      {
        Header         : 'Price',
        accessor       : 'price',
        Cell           : PriceCell,
        disableFilters : true
      },
      {
        Header         : 'Selling Price',
        accessor       : 'selling_price',
        Cell           : PriceCell,
        disableFilters : true
      },
      {
        Header   : 'Status',
        accessor : 'status'
      },
      {
        Header   : 'Seller Name',
        accessor : 'seller_name'
      }
    ]
  )
}

export default productTableColumns
